import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ClipboardService } from '@portal-core/general/services/clipboard.service';
import { DialogBase } from '@portal-core/ui/dialog/util/dialog.base';
import { SnackBarAutoDismissDurationMS } from '@portal-core/ui/snack-bar/constants/snack-bar-auto-dismiss-duration.constant';

export interface LogDialogData {
  code?: string;
  message?: string;
  title?: string;
}

@Component({
  selector: 'mc-log-dialog',
  templateUrl: './log-dialog.component.html',
  styleUrls: ['./log-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogDialogComponent extends DialogBase implements OnInit {
  /** The default config for the dialog. */
  static DialogConfig: MatDialogConfig = {
    minHeight: '15rem',
    width: '80rem'
  };

  title: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LogDialogData,
    protected dialog: MatDialog,
    protected dialogRef: MatDialogRef<LogDialogComponent>,
    private snackBar: MatSnackBar,
    private clipboardService: ClipboardService
  ) {
    super(dialog, dialogRef);
  }

  ngOnInit() {
    super.ngOnInit();
    this.title = this.data?.title ?? 'Message';
  }

  copyMessage() {
    const isCopied = this.clipboardService.copy(this.data.message ?? this.data.code ?? '');
    let message: string;

    if (isCopied) {
      message = 'Copied to clipboard';
    } else {
      message = 'Copy failed';
    }

    this.snackBar.open(message, null, {
      duration: SnackBarAutoDismissDurationMS
    });
  }
}
